import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id A39D910A-D5C9-4A9D-86CF-F61A60486758
 * name pipe-leak
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pipe-leak.svg
 * tags
 * - Home Automation 
 */
export const PipeLeakIcon = createSvgIcon(<><path d="M2,5V13H4V11H10L12,9L10,7H4V5H2M20,5V7H12L14,9L12,11H20V13H22V5H20M12,13C12,13 10,15.17 10,16.5A2,2 0 0,0 12,18.5A2,2 0 0,0 14,16.5C14,15.17 12,13 12,13Z" /></>, 'PipeLeakIcon');
export default PipeLeakIcon